<template>
  <div class="nx-scrollytelling-slide-editor-list">
    <nx-relation-editor-toolbar title="Listado de bloques">
      <template slot="actions">
        <v-tooltip class="button-add" top>
          <v-btn icon small @click="create" slot="activator">
            <v-icon>add</v-icon>
          </v-btn>
          <span>{{ $t('message.relation.add') }}></span>
        </v-tooltip>
      </template>
    </nx-relation-editor-toolbar>
    <div ref="list" class="mt-3" :class="{ moving }">
      <nx-scrollytelling-slide-list-item v-for="(slide, index) in value"
                                         :class="{ 'mt-1': index > 0, 'draggable': index > 0 }"
                                         :key="slide.uuid"
                                         :uuid="slide.uuid"
                                         :name="slide.name"
                                         :type="slide.type"
                                         :draggable="index > 0"
                                         @click="handleEdit(slide, index)"/>
    </div>
    <nx-relation-empty-card v-if="isEmpty"
                            :show-icon="false"
                            text="message.content.editor.scrollytelling.emptyList"/>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import NxScrollytellingSlideListItem from '@/modules/scrollytelling/components/ScrollytellingSlideListItem';
import cloneDeep from 'lodash/cloneDeep';
import NxRelationEditorToolbar from '@/modules/relation/editor/components/Toolbar';
import NxRelationEmptyCard from '@/modules/relation/card/EmptyCard';

export default {
  name: 'nx-scrollytelling-slide-list',
  components: {
    NxRelationEmptyCard,
    NxRelationEditorToolbar,
    NxScrollytellingSlideListItem,
  },
  props: {
    disabled: {
      type: Boolean,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      moving: false,
    };
  },
  computed: {
    isEmpty() {
      return this.value.length === 0;
    },
  },
  methods: {
    create() {
      this.$emit('create');
    },
    move(from, to) {
      const cloned = cloneDeep(this.value);
      cloned.splice(to, 0, cloned.splice(from, 1)[0]);
      this.$emit('move', cloned);
    },
    handleEdit(slide, index) {
      this.$emit('edit', { slide, index });
    },
  },
  mounted() {
    this.sortablejs = Sortable.create(this.$refs.list, {
      handle: '.nx-drag-handle',
      onUpdate: ({
        oldIndex,
        newIndex,
      }) => this.move(oldIndex, newIndex),
      onStart: () => {
        this.moving = true;
      },
      onEnd: () => {
        this.moving = false;
      },
      onMove: evt => evt.related.className.indexOf('draggable') !== -1,
    });
  },
};
</script>


<style lang="stylus">
@import '../../../assets/stylus/variables.styl'

// style
.nx-scrollytelling-slide-editor-list {
  &.moving {
    *:not(.sortable-chosen) {
      opacity: .7;
    }
  }

  .button-add {
    margin-right: 12px;
  }
}

.nx-scrollytelling-slide-editor .nx-relation-editor-toolbar-wrapper .v-toolbar__title {
  height: 24px
  font-family: Roboto, serif
  font-size: 17px
  font-weight: 500
  font-stretch: normal
  font-style: normal
  line-height: 1.41
  letter-spacing: normal
  text-transform: uppercase
  color: $nx-primary--darken-1
}
</style>
